export const adminRoles = {
  SALES: 'SALES',
  ART: 'ART',
  CS: 'CS',
  USER: 'USER',
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  TELEMARKETER: 'TELEMARKETER',
  PRODUCTION: 'PRODUCTION',
  OPERATIONS: 'OPERATIONS',
  ACCOUNTING: 'ACCOUNTING',
  CUSTOMER_CARE: 'CUSTOMER_CARE',
  DIGITAL_TRAFFICKING: 'DIGITAL_TRAFFICKING'
};

export const paymentTypes = {
  MONTHLY_SUBSCRIPTION: 'monthly_subscription',
  ANNUAL_SUBSCRIPTION: 'annual_subscription',
  INSTALLMENTS: 'installment',
  PREPAID: 'prepaid'
};

export const campaignDurationLabel = {
  [paymentTypes.MONTHLY_SUBSCRIPTION]: 'Monthly (recurring)',
  [paymentTypes.ANNUAL_SUBSCRIPTION]: '12 Months (annual)',
  [paymentTypes.INSTALLMENTS]: 'Installment Payments',
  [paymentTypes.PREPAID]: 'Pay in Full'
};

export const paymentTypesOptions = [
  {
    label: campaignDurationLabel[paymentTypes.MONTHLY_SUBSCRIPTION],
    id: paymentTypes.MONTHLY_SUBSCRIPTION
  },
  {
    label: campaignDurationLabel[paymentTypes.ANNUAL_SUBSCRIPTION],
    id: paymentTypes.ANNUAL_SUBSCRIPTION
  }
];

export const discountTypes = {
  ONE_MONTH_FREE: '1_Month_Free',
  TWO_MONTHS_FREE: '2_Months_Free',
  OTHER: 'Other'
};

export const discountTypeLabel = {
  [discountTypes.ONE_MONTH_FREE]: '1 Month Free',
  [discountTypes.TWO_MONTHS_FREE]: '2 Months Free',
  [discountTypes.OTHER]: 'Other'
};

export const campaignTypes = {
  1: 'Wellness billboard',
  2: 'Digital ads',
  3: 'Social media ads'
};

export const emptyCampaign = {
  name: '',
  companyId: '',
  startDate: '',
  kiosks: [],
  payment: {},
  artPreferences: {},
  designArts: [],
  admins: null,
  transactions: []
};

export const placementTypes = {
  TOP_AND_BOTTOM: 'TOP_AND_BOTTOM',
  TOP: 'TOP'
};

export const placementTypeLabels = {
  TOP_AND_BOTTOM: 'Combo (Top & Bottom)',
  TOP: 'Top Only'
};

export const placementTypesOptions = [
  {
    label: placementTypeLabels.TOP_AND_BOTTOM,
    id: placementTypes.TOP_AND_BOTTOM
  },
  {
    label: placementTypeLabels.TOP,
    id: placementTypes.TOP
  }
];

export const transactionsTypes = {
  production_fee: 'Production Fee'
};

export const kioskBookingStatuses = {
  BOOKED: 'booked',
  AVAILABLE: 'available'
};

export const artBriefRequestTypes = {
  1: 'Request Creative Freedom for Designers',
  2: 'Request to Match Template Selected'
};

export const artBriefRequestTypesValue = {
  'Request Creative Freedom for Designers': 1,
  'Request to Match Template Selected': 2
};

export const adminForceSignature = 'admin_signature';

export const campaignBillingStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  PENDING: 'PENDING',
  DECLINED: 'DECLINED',
  CANCELED: 'CANCELED',
  FAILED: 'FAILED'
};

export const allCampaignBillingStatuses = Object.values(campaignBillingStatus).join(',');

export const campaignBillingStatusLabels = {
  [campaignBillingStatus.ACTIVE]: 'Active',
  [campaignBillingStatus.PAUSED]: 'Paused',
  [campaignBillingStatus.PENDING]: 'Pending',
  [campaignBillingStatus.DECLINED]: 'Declined',
  [campaignBillingStatus.CANCELED]: 'Canceled',
  [campaignBillingStatus.FAILED]: 'Failed'
};

export const campaignBillingStatusOptions = [
  {
    label: campaignBillingStatusLabels[campaignBillingStatus.ACTIVE],
    value: campaignBillingStatus.ACTIVE
  },
  {
    label: campaignBillingStatusLabels[campaignBillingStatus.PAUSED],
    value: campaignBillingStatus.PAUSED
  },
  {
    label: campaignBillingStatusLabels[campaignBillingStatus.PENDING],
    value: campaignBillingStatus.PENDING
  },
  {
    label: campaignBillingStatusLabels[campaignBillingStatus.DECLINED],
    value: campaignBillingStatus.DECLINED
  },
  {
    label: campaignBillingStatusLabels[campaignBillingStatus.CANCELED],
    value: campaignBillingStatus.CANCELED
  },
  {
    label: campaignBillingStatusLabels[campaignBillingStatus.FAILED],
    value: campaignBillingStatus.FAILED
  }
];


export const getVenueLogo = (venueName = null) => {
  if (!venueName) {
    return "/images/stores/default.png";
  }

  // Format name: spaces -> underscores, lowercase
  const formatted = venueName.replace(/\s+/g, "_").toLowerCase();
  return `/images/stores/${formatted}.png`;
};

export const getKioskType = (inputKiosk) => {
  const typeName = inputKiosk?.type || "";
  if (!typeName.trim()) {
    return "/images/kiosk-types/default.png";
  }

  const formatted = typeName.replace(/\s+/g, "_").toLowerCase();
  return `/images/kiosk-types/${formatted}.png`;
};

export const addMonths = (date, months) => {
  if (!date || isNaN(date)) return null;
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
};

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};